// export default ShowRdv;
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Formik, Form, Field } from "formik";
import {
  formatDecimalHour,
  formatFrenchDate,
  formatMinutesToHourMinute,
  lieuIntervention,
  StatusRdv,
} from "../../utils/utils";
import { fetchCalendarData } from "../../store/slices/rendezVousPrestaSlice";
import { useDispatch } from "react-redux";
import { updateRendezVous } from "../../store/slices/rendezVousSlice";
import Popup from "../Popup";
import { handleAcceptationRdv } from "./AcceptationRdv";
import { RefusRdv } from "./RefusRdv";

function ShowRdvStandart({
  handleShow,
  handleClose,
  setShowedit,
  show,
  ...props
}) {
  // console.log("props.event in show page:", props?.event);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupActionType, setPopupActionType] = useState(null); // 'Rendez-vous En Attente ou Confirmé'
  const rendezVous = props?.event;
  const locationIcons = lieuIntervention();
  const statusIcons = StatusRdv();
  const dispatch = useDispatch();

  const handlePopupAction = () => {
    RefusRdv({ dispatch, rendezVous, handleClose, setPopupVisible });
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        placement="end"
        className="showRdv"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="agendaTiltle">
            Détails du rendez-vous
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Formik initialValues={rendezVous} onSubmit={() => {}}>
            {() => (
              <Form className="m-24">
                <div className="mb-16">
                  <span className="me-2">
                    {/* <img src="/images/attente.svg" alt="/images/status.svg" /> */}
                    <img
                      src={statusIcons[rendezVous?.status]}
                      alt={rendezVous?.status}
                    />
                  </span>
                  <span>
                    <img
                      src={locationIcons[rendezVous?.lieu_intervention]}
                      alt={rendezVous?.lieu_intervention}
                    />
                  </span>
                </div>

                <h5 className="mb-8">
                  {" "}
                  {formatFrenchDate(rendezVous?.start_time)}{" "}
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />{" "}
                  {new Date(rendezVous?.start_time).toLocaleTimeString(
                    "fr-FR",
                    {
                    // timeZone: "Europe/Paris",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}{" "}
                  -{" "}
                  {new Date(rendezVous?.end_time).toLocaleTimeString("fr-FR", {
                  //  timeZone: "Europe/Paris",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </h5>
                <p className="body grey-light mb-24">
                  {rendezVous?.activite?.name}
                </p>
                {rendezVous?.prestations_snapshot?.map((prestation, index) => (
                  <>
                    <div className="body bold500 mb-8">{prestation?.name}</div>
                    <div className="mb-2 body grey-light">
                      <img
                        src="/images/timer.svg"
                        alt="Duration"
                        className="me-2"
                      />
                      {/* {prestation?.duree}, {prestation?.nbr_seances} séances */}
                      {formatMinutesToHourMinute(prestation?.duree)},{" "}
                      {prestation?.nbr_seances} séance(s)
                      <img
                        src="/images/separateur.svg"
                        alt="separateur"
                        className="me-2 ms-2"
                      />
                      <img
                        src="/images/coin.svg"
                        alt="Price"
                        className="me-2"
                      />
                      {prestation?.ttc.toFixed(2)}€ TTC
                    </div>
                    <div className="mb-3 body grey-light mb-16">
                      {rendezVous?.etablissement?.adresse_postale},{" "}
                      {rendezVous?.etablissement?.code_postal}{" "}
                      {rendezVous?.etablissement?.ville}
                    </div>
                  </>
                ))}
               {rendezVous?.equipe?.name && 
               <div className="mb-3">
                  <div className="body bold500 mb-8">Salarié</div>
                  <div className="body grey-light d-flex">
                    <img
                      src="/images/user-profile-gray.svg"
                      alt="profil"
                      className="me-2"
                    />
                    {rendezVous?.equipe?.name}
                  </div>
                </div>
               } 

                <div className="mb-3">
                  <div className="body bold500 mb-8">Client</div>
                  <div className="body grey-light mb-8">
                    <img
                      src="/images/user-profile-gray.svg"
                      alt="profil"
                      className="me-2"
                    />
                    {rendezVous?.user?.prenom} {rendezVous?.user?.nom}
                  </div>
                  <div className="body grey-light mb-8">
                    <img src="/images/mail.svg" alt="mail" className="me-2" />
                    {rendezVous?.user?.email}
                  </div>
                  <div className="body grey-light mb-8">
                    <img
                      src="/images/tel.svg"
                      alt="Téléphone"
                      className="me-2"
                    />
                    {rendezVous?.user?.phone_number}
                  </div>
                </div>
                {rendezVous?.lieu_intervention === "onsite" ? (
                  <div className="infos-location">
                    <span className="body grey-light">
                      <img src="/images/location.svg" alt="Address" />{" "}
                      {rendezVous?.adresse_domicile}
                    </span>
                  </div>
                ) : rendezVous?.lieu_intervention === "chezpro" ? (
                  <div className="infos-location">
                    <span className="body grey-light mb-8">
                      <img src="/images/location.svg" alt="Address" />{" "}
                      {rendezVous?.etablissement?.code_postal}{" "}
                      {rendezVous?.etablissement?.ville}{" "}
                      {rendezVous?.etablissement?.adresse_postale}
                    </span>
                  </div>
                ) : rendezVous?.lieu_intervention === "enligne" &&
                  rendezVous?.meeting_link ? (
                  <div className="video-conference">
                    <p className="body bold500 link">
                      Lien de la visioconférence
                    </p>
                    <a
                      href={rendezVous?.meeting_link}
                      className="video-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/link.svg" alt="Vidéoconférence" />
                      {rendezVous?.meeting_link}
                    </a>
                  </div>
                ) : (
                  <p className="body grey66">En ligne</p>
                )}
              </Form>
            )}
          </Formik>
        </Offcanvas.Body>
        <div className="offcanvas-footer mb-24">
          <div className="container plr24">
            {rendezVous?.status == "confirme" ? (
              <>
                <div className="mt-4 w-30 mt-719">
                  <Button
                    type="submit"
                    variant="secondary"
                    className="twyny-cta-secondary padding-submit width-100"
                    onClick={() => {
                      setShowedit(true);
                      handleClose();
                    }}
                  >
                    Modifier le rendez-vous
                  </Button>
                </div>
                <div className="mt-4 w-30 mt-8">
                  <Button
                    onClick={() => {
                      setPopupVisible(true);
                      setPopupActionType("confirme");
                    }}
                    className="btn-annulation padding-submit width-100"
                  >
                    Annuler le rendez-vous
                  </Button>
                </div>
              </>
            ) : rendezVous?.status == "enattente" ? (
              <div>
                <Button
                  type="submit"
                  variant="primary"
                  className="twyny-cta-primary padding-submit width-100"
                  onClick={() =>
                    handleAcceptationRdv(dispatch, rendezVous, handleClose)
                  }
                >
                  Accepter
                </Button>
                <div className="mt-4 w-30 mt-8">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setPopupVisible(true);
                      setPopupActionType("enattente");
                    }}
                    className="twyny-cta-secondary padding-submit width-100"
                  >
                    Refuser
                  </Button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </Offcanvas>
      {isPopupVisible && (
        <Popup
          isOpen={isPopupVisible}
          onClose={() => {
            setPopupVisible(false);
          }}
          onAction={() => handlePopupAction()}
          title={
            popupActionType === "enattente"
              ? "Attention, vous allez refuser un rendez-vous. Êtes-vous sûr de vouloir poursuivre ?"
              : "Attention, vous allez annuler un rendez-vous. Êtes-vous sûr de vouloir poursuivre ?"
          }
          text={
            <p className="body">
              Vous ne pourrez plus voir ou accepter cette demande.
            </p>
          }
          actionButtonText={
            popupActionType === "enattente"
              ? "Refuser le rendez-vous"
              : "Annuler le rendez-vous"
          }
          closeButtonText={
            popupActionType === "enattente" ? "Annuler" : "Conserver"
          }
          closeButtonClassName="bold600"
          color="red"
          icon={
            <svg
              width="88"
              height="88"
              viewBox="0 0 88 88"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="88"
                height="88"
                rx="14.6667"
                fill="#DD1E03"
                fillOpacity="0.1"
              />
              <path
                d="M44.4001 44.4001V34.5001M44.4001 51.7381V51.8251M64.2001 44.4001C64.2001 55.3353 55.3353 64.2001 44.4001 64.2001C33.4649 64.2001 24.6001 55.3353 24.6001 44.4001C24.6001 33.4649 33.4649 24.6001 44.4001 24.6001C55.3353 24.6001 64.2001 33.4649 64.2001 44.4001Z"
                stroke="#DD1E03"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
        />
      )}
    </>
  );
}

export default ShowRdvStandart;
